 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_SERIES_EDITOR from '@/components/xhtml/01_Series_Editor'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_ACKNOWLEDGMENTS from '@/components/xhtml/06_ACKNOWLEDGMENTS'
 import XHTML07_1__BREAKING_THE_COVENANT from '@/components/xhtml/07_1__Breaking_the_Covenant'
 import XHTML08_2__PRINT_MEDIA from '@/components/xhtml/08_2__Print_Media'
 import XHTML09_3__ARTS_AND_POPULAR_CULTURE from '@/components/xhtml/09_3__Arts_and_Popular_Culture'
 import XHTML10_4__TELEVISION_COVERAGE from '@/components/xhtml/10_4__Television_Coverage'
 import XHTML11_CONCLUSION from '@/components/xhtml/11_Conclusion'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML12_NOTES from '@/components/xhtml/12_NOTES'
 import XHTML13_BIBLIOGRAPHY from '@/components/xhtml/13_BIBLIOGRAPHY'
 import XHTML14_ABOUT_THE_AUTHOR_AND_SERIES_EDIT from '@/components/xhtml/14_ABOUT_THE_AUTHOR_AND_SERIES_EDIT'
 import XHTML15_INDEX from '@/components/xhtml/15_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_ACKNOWLEDGMENTS",
 			"name" : "xhtml/06_ACKNOWLEDGMENTS",
 			"component" : XHTML06_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/07_1__Breaking_the_Covenant",
 			"name" : "xhtml/07_1__Breaking_the_Covenant",
 			"component" : XHTML07_1__BREAKING_THE_COVENANT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js